export type InsightType = 'ai' | 'manual';
export type InsightSource = 'email' | 'sms' | 'call' | 'chat' | 'manual' | 'agent';
export type AiInsightSeverity = 'info' | 'warn' | 'danger' | 'success';
export type FeedbackSentiment = 'helpful' | 'notHelpful';

export type FeedbackReason =
  | 'accurate'
  | 'actionable'
  | 'timely'
  | 'inaccurate'
  | 'irrelevant'
  | 'outdated'
  | 'other';

export interface InsightFeedback {
  sentiment: FeedbackSentiment;
  reason: FeedbackReason | null;
  comment: string;
  submittedAt: string;
}

export interface AiInsight {
  id: string;
  type: InsightType;
  title: string;
  body: string;
  source: InsightSource;
  severity: AiInsightSeverity;
  createdAt: string;
  /** 0–1, AI insights only */
  confidence: number | null;
  /** true when generated by an autonomous agent */
  agentGenerated: boolean;
  /** whether the FA has seen this insight */
  seen: boolean;
  feedback: InsightFeedback | null;
  /** optional link to source conversation/document */
  sourceRef: string | null;
  tags: string[];
}

export interface ClientAiInsightsState {
  insights: AiInsight[];
  /** total AI-generated insights added in last 24 h */
  newInsights24h: number;
  /** total AI-generated insights added in last 7 d */
  newInsights7d: number;
  /** count of high-priority / danger insights */
  highPriorityCount: number;
  /** count of agent-generated suggestions */
  agentSuggestionCount: number;
  /** approximate FA time saved in minutes */
  timeSavedMinutes: number;
}
